import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface PathologyProcessListState {
    list: string[][],
  }
  
const initialState:PathologyProcessListState = {
    list:[],
}

export const PathologyProcessListSlice = createSlice({
    name:"pathologyProcessList",
    initialState,
    reducers:{
        UpdatePathologyProcessList: (state,action) => {
            state.list = action.payload.pathologyProcessList;
        },
        AddPathologyProcess: (state,action) => {
            state.list = [];
        },
        EditPathologyProcess: (state,action) => {
            state.list = [];
        },
        RemovePathologyProcess: (state,action) => {
            state.list = [];
        }
    }
})

export const {UpdatePathologyProcessList,AddPathologyProcess,EditPathologyProcess,RemovePathologyProcess} = PathologyProcessListSlice.actions

export const selectPathologyProcessList = (state: RootState) => state.pathologyProcessList

export default PathologyProcessListSlice.reducer;